(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shop-all"] && !Shopify.designMode) return;
  try {
    
  // Filter pills: one per collection group, filtering the groups on the page without reloading.
  const buildShopAllPills = (root) => {
    const pills = root.querySelector('[data-shop-all-pills]');
    if (!pills) return;
    pills.querySelectorAll('[data-shop-all-filter]:not([data-shop-all-filter="all"])').forEach((pill) => pill.remove());

    root.querySelectorAll('[data-shop-all-pill]').forEach((group) => {
      const pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'shop-all__pill';
      pill.dataset.shopAllFilter = group.getAttribute('data-shop-all-group');
      pill.setAttribute('aria-pressed', 'false');
      pill.textContent = group.getAttribute('data-shop-all-pill');
      pills.append(pill);
    });
    pills.hidden = pills.children.length < 2;
  };

  const initShopAll = () => document.querySelectorAll('.shop-all').forEach(buildShopAllPills);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopAll);
  } else {
    initShopAll();
  }
  document.addEventListener('shopify:section:load', initShopAll);
  document.addEventListener('shopify:block:select', initShopAll);

  document.addEventListener('click', (event) => {
    const pill = event.target instanceof Element ? event.target.closest('[data-shop-all-filter]') : null;
    if (!pill) return;

    const root = pill.closest('.shop-all');
    const filter = pill.getAttribute('data-shop-all-filter');
    root.querySelectorAll('[data-shop-all-filter]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === pill));
    });
    root.querySelectorAll('[data-shop-all-group]').forEach((group) => {
      group.hidden = filter !== 'all' && group.getAttribute('data-shop-all-group') !== filter;
    });

    // The page height changed; let smooth-scroll/ScrollTrigger recalculate.
    window.dispatchEvent(new Event('resize'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-header-offer"]) return;
  try {
    
    (() => {
      if (window.customCollectionHeaderTabsInitialized) return;
      window.customCollectionHeaderTabsInitialized = true;

      const activeClass = 'custom-collection-nav__link--active';

      const getHandleFromLink = (link) => {
        const handle = link.dataset.collectionHandle?.trim();
        if (handle) return handle;

        const href = link.getAttribute('href');
        if (!href) return '';

        try {
          const pathParts = new URL(href, window.location.origin).pathname.split('/').filter(Boolean);
          const collectionsIndex = pathParts.indexOf('collections');
          return collectionsIndex >= 0 ? pathParts[collectionsIndex + 1] || '' : '';
        } catch {
          return '';
        }
      };

      const getSections = () => Array.from(document.querySelectorAll('.custom-collection-section[data-collection-handle]'));

      const getSectionNodes = (section) => {
        const nodes = [section];
        const background = section.previousElementSibling;

        if (background?.classList.contains('section-background')) {
          nodes.unshift(background);
        }

        return nodes;
      };

      const setActiveLink = (nav, activeLink) => {
        for (const link of nav.querySelectorAll('.custom-collection-nav__link')) {
          const isActive = link === activeLink;
          link.classList.toggle(activeClass, isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'page');
          } else {
            link.removeAttribute('aria-current');
          }
        }
      };

      const setSectionVisibility = (section, isVisible) => {
        for (const node of getSectionNodes(section)) {
          node.style.display = isVisible ? '' : 'none';
          node.style.opacity = '';
        }
      };

      const showAllSections = () => {
        for (const section of getSections()) {
          setSectionVisibility(section, true);
        }
      };

      const refreshNavVisibility = () => {
        const sections = getSections();
        if (!sections.length) return;

        const availableHandles = new Set(sections.map((section) => section.dataset.collectionHandle).filter(Boolean));
        const isLinkVisible = (link) => link.style.display !== 'none';

        for (const nav of document.querySelectorAll('custom-collection-nav')) {
          const links = Array.from(nav.querySelectorAll('.custom-collection-nav__link'));

          for (const link of links) {
            const showAll = link.dataset.showAll === 'true';
            const handle = getHandleFromLink(link);
            const isVisible = showAll || availableHandles.has(handle);

            link.style.display = isVisible ? '' : 'none';
            link.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
            link.tabIndex = isVisible ? 0 : -1;
          }

          const activeLink = nav.querySelector(`.${activeClass}`);
          if (activeLink && !isLinkVisible(activeLink)) {
            const allLink = links.find((link) => link.dataset.showAll === 'true');
            const fallbackLink = links.find(isLinkVisible);
            const nextActiveLink = allLink || fallbackLink;

            if (nextActiveLink) {
              setActiveLink(nav, nextActiveLink);
              showAllSections();
            }
          }
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', refreshNavVisibility, { once: true });
      } else {
        refreshNavVisibility();
      }

      document.addEventListener('shopify:section:load', refreshNavVisibility);

      document.addEventListener(
        'click',
        (event) => {
          if (!(event.target instanceof Element)) return;

          const link = event.target.closest('.custom-collection-nav__link');
          if (!link || !link.closest('.custom-collection-nav__content')) return;

          const nav = link.closest('custom-collection-nav');
          const sections = getSections();
          if (!nav || !sections.length) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          const showAll = link.dataset.showAll === 'true';
          const handle = getHandleFromLink(link);
          const hasMatch = showAll || sections.some((section) => section.dataset.collectionHandle === handle);

          setActiveLink(nav, link);

          for (const section of sections) {
            setSectionVisibility(section, showAll || !hasMatch || section.dataset.collectionHandle === handle);
          }
        },
        true
      );
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection"] && !Shopify.designMode) return;
  try {
    
    const url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(url.hash.slice(1));
          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  // YouTube autoplay via JS API (avoids pause button) + loop without playlist
  (function() {
    const wrappers = document.querySelectorAll('[data-youtube-loop]');
    if (!wrappers.length) return;

    // Load YouTube API
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }

    const initPlayers = function() {
      wrappers.forEach(wrapper => {
        const iframe = wrapper.querySelector('iframe');
        if (!iframe || iframe.dataset.ytInitialized) return;
        iframe.dataset.ytInitialized = 'true';

        // Add enablejsapi to src if not present
        if (!iframe.src.includes('enablejsapi=1')) {
          iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'enablejsapi=1';
        }

        const player = new YT.Player(iframe, {
          events: {
            onReady: function(event) {
              event.target.mute();
              event.target.playVideo();
            },
            onStateChange: function(event) {
              // When video ends, restart it (loop)
              if (event.data === YT.PlayerState.ENDED) {
                player.seekTo(0);
                player.playVideo();
              }
            }
          }
        });
      });
    };

    window.onYouTubeIframeAPIReady = initPlayers;

    // If API already loaded
    if (window.YT && window.YT.Player) {
      initPlayers();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  // Arrows scroll by one card; dots show and jump between "pages" (one track width each).
  const initProductCarousel = (root) => {
    const track = root.querySelector('[data-carousel-track]');
    const dots = root.querySelector('[data-carousel-dots]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';

    const step = () => {
      const slide = track.querySelector('.product-rail__slide');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
    };
    const pages = () => Math.max(1, Math.ceil((track.scrollWidth - 1) / track.clientWidth));

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
      const active = track.scrollLeft >= max ? pages() - 1 : Math.round(track.scrollLeft / track.clientWidth);
      dots?.querySelectorAll('button').forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === active));
      });
    };

    const renderDots = () => {
      if (!dots) return;
      const count = pages();
      dots.replaceChildren();
      dots.hidden = count < 2;
      for (let index = 0; index < count; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'product-rail__dot';
        dot.setAttribute('aria-label', `Go to page ${index + 1} of ${count}`);
        dot.addEventListener('click', () => track.scrollTo({ left: index * track.clientWidth }));
        dots.append(dot);
      }
      update();
    };

    prev?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next?.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', update, { passive: true });
    renderDots();
    new ResizeObserver(renderDots).observe(track);
  };

  const initProductCarousels = () => document.querySelectorAll('[data-product-rail]').forEach(initProductCarousel);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCarousels);
  } else {
    initProductCarousels();
  }
  document.addEventListener('shopify:section:load', initProductCarousels);

  } catch(e) { console.error(e); }
})();
})();
